/**
 * Market Insights view configuration constants.
 * Centralizes view types, storage keys, and event names.
 */

// View types for Index section
export const INDEX_VIEWS = {
  INDEX: 'index',
  VALUATION: 'valuation',
  TREEMAP: 'treemap',
};

// View types for Coverage section
export const COVERAGE_VIEWS = {
  MARKET: 'market',
};

// View types for Acquisitions section
export const ACQUISITIONS_VIEWS = {
  PUBLIC: 'public',
  DASHBOARD: 'dashboard',
  TOTAL: 'total',
  ACQUIRERS: 'acquirers',
  SPONSORS: 'sponsors',
};

// Storage keys for view preference persistence
export const INDEX_VIEW_STORAGE_KEY = 'marketInsightsIndexView';
export const COVERAGE_VIEW_STORAGE_KEY = 'marketInsightsCoverageView';
export const ACQUISITIONS_VIEW_STORAGE_KEY = 'marketInsightsAcquisitionsView';

// Event names for cross-component view change communication
export const INDEX_VIEW_EVENT_NAME = 'marketInsightsViewChange';
export const COVERAGE_VIEW_EVENT_NAME = 'marketInsightsCoverageViewChange';
export const ACQUISITIONS_VIEW_EVENT_NAME = 'marketInsightsAcquisitionsViewChange';
